module.exports = __webpack_public_path__ + "static/media/background02.b48623d3.jpg";